// extracted by mini-css-extract-plugin
module.exports = {"form":"footer-form-module--form--IM6_g","submit":"footer-form-module--submit--1x6rq","select":"footer-form-module--select--1tlfM"};